import styles from './styles.module.scss'

interface IBlogDetailProps {
  data: {
    id: string;
    text: string;
  }[];
  title: string;
}

export default function Contents (props: IBlogDetailProps) {
  const { data, title } = props
  return (
    <div className={styles.contents}>
      <h3 className={styles.contents__title}>{title}</h3>
      <ul className={styles.contents__list}>
        {data.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              dangerouslySetInnerHTML={{ __html: item.text }}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
